import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sp-textfield"
    }}>{`sp-textfield`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v4.1`}</p>
    <p>{`Renders a text field with optional associated label.`}</p>
    <p><img alt="Text areas" src={require("../../assets/sp-textfield.png")} /></p>
    <p><strong parentName="p">{`See`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spectrum.adobe.com/page/text-field/"
        }}>{`https://spectrum.adobe.com/page/text-field/`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://opensource.adobe.com/spectrum-web-components/components/textfield"
        }}>{`https://opensource.adobe.com/spectrum-web-components/components/textfield`}</a></li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-textfield placeholder="Phone Number">
    <sp-label isrequired="true" slot="label">Phone Number</sp-label>
</sp-textfield>
`}</code></pre>
    <h2 {...{
      "id": "variants-and-states"
    }}>{`Variants and states`}</h2>
    <p>{`There are several different variants for text fields.`}</p>
    <h3 {...{
      "id": "disabled"
    }}>{`Disabled`}</h3>
    <p>{`Indicates that the text field is disabled.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-textfield disabled placeholder="Phone Number"><sp-textfield>
`}</code></pre>
    <h3 {...{
      "id": "valid"
    }}>{`Valid`}</h3>
    <p>{`Indicates that the value of the text field is valid.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-textfield valid placeholder="Phone Number"><sp-textfield>
`}</code></pre>
    <h3 {...{
      "id": "invalid"
    }}>{`Invalid`}</h3>
    <p>{`Indicates that the value of the text field is invalid.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-textfield invalid placeholder="Phone Number"><sp-textfield>
`}</code></pre>
    <h3 {...{
      "id": "quiet"
    }}>{`Quiet`}</h3>
    <p>{`Styles the text field in a quieter, simpler appearance.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-textfield quiet placeholder="Phone Number"><sp-textfield>
`}</code></pre>
    <h3 {...{
      "id": "numeric-fields"
    }}>{`Numeric fields`}</h3>
    <p>{`Restricts the text field to numeric data. You cannot currently specify minimum, maximum, or steps. The numeric value must be between -214,748.36 and 214,748.36, or an error will be displayed and the value capped to the nearest acceptable value.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-textfield type="number" placeholder="Age"><sp-textfield>
`}</code></pre>
    <h3 {...{
      "id": "search-fields"
    }}>{`Search fields`}</h3>
    <p>{`Adds a search icon to indicate that the text will be used for searching.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-textfield type="search" placeholder="Age"><sp-textfield>
`}</code></pre>
    <h3 {...{
      "id": "password-fields"
    }}>{`Password fields`}</h3>
    <p>{`Styles the entered text in a way that it is not visible what is being typed.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-textfield type="password" placeholder="Age"><sp-textfield>
`}</code></pre>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`The password field's `}<inlineCode parentName="p">{`value`}</inlineCode>{` cannot be read on macOS. This is a bug and will be fixed in the future. You can work around this by switching the `}<inlineCode parentName="p">{`type`}</inlineCode>{` to `}<inlineCode parentName="p">{`text`}</inlineCode>{` on `}<inlineCode parentName="p">{`focus`}</inlineCode>{`, and then switching the `}<inlineCode parentName="p">{`type`}</inlineCode>{` back to `}<inlineCode parentName="p">{`password`}</inlineCode>{` on `}<inlineCode parentName="p">{`blur`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "responding-to-events"
    }}>{`Responding to events`}</h2>
    <p>{`You can respond to changes on the text area using the `}<inlineCode parentName="p">{`change`}</inlineCode>{` and `}<inlineCode parentName="p">{`input`}</inlineCode>{` events.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`document.querySelector(".yourTextField").addEventListener("input", evt => {
    console.log(\`New value: \${evt.target.value}\`);
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      